import { render } from "./subpartA05.vue?vue&type=template&id=16cde5f8&scoped=true"
import script from "./subpartA05.vue?vue&type=script&lang=js"
export * from "./subpartA05.vue?vue&type=script&lang=js"

import "./subpartA05.vue?vue&type=style&index=0&id=16cde5f8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cde5f8"]])

export default __exports__